import { combineReducers } from 'redux';

import auth from './auth';
import filters from './filters';

export default combineReducers({
	auth,
	filters
});
